import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { RadioButton } from './RadioButton.js';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage.js';
import { HelpText } from '../HelpText/HelpText.js';

/* eslint-disable @typescript-eslint/no-explicit-any */

var RadioButtons = props => {
  var fieldsetAttributes = {
    className: 'form-group form-checkboxlist',
    id: props.id
  };
  var inputName = props.name ? props.name : props.id;
  var headings = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
  var hcid = "".concat(RadioButtons.name.toLocaleLowerCase(), "-").concat("10.6.2");
  var [labelChild, setLabelChild] = React.useState(props.label);
  var ErrorMessageComponent;
  var HelpTextComponent;
  if (typeof props.isValid === 'boolean' && props.isValid === false) {
    // Invalid
    fieldsetAttributes.className += ' is-invalid';
    fieldsetAttributes['aria-invalid'] = true;

    // Invalid with error message
    if (props.errormessage) {
      fieldsetAttributes['aria-describedby'] = "".concat(props.id, "-errormessage");
      ErrorMessageComponent = /*#__PURE__*/React.createElement(ErrorMessage, {
        id: props.id,
        message: props.errormessage,
        IconTheme: props.ErrorMessageIconTheme
      });
    }
  } else if (props.helptext) {
    fieldsetAttributes['aria-describedby'] = "".concat(props.id, "-helptext");
    HelpTextComponent = /*#__PURE__*/React.createElement(HelpText, {
      id: props.id
    }, props.helptext);
  }
  if (props.required) {
    fieldsetAttributes['aria-required'] = true;
    fieldsetAttributes.role = 'radiogroup';
  }
  React.useEffect(() => {
    if (props.headingTag && headings.includes(props.headingTag.toLowerCase())) {
      var _props$headingTag;
      setLabelChild( /*#__PURE__*/React.createElement((_props$headingTag = props.headingTag) === null || _props$headingTag === void 0 ? void 0 : _props$headingTag.toLowerCase(), null, props.label));
    } else if (props.isLabelHeading) {
      setLabelChild( /*#__PURE__*/React.createElement('h1', null, props.label));
    } else {
      setLabelChild(props.label);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.headingTag, props.isLabelHeading]);
  return /*#__PURE__*/React.createElement("fieldset", _extends({}, fieldsetAttributes, {
    "data-hcid": hcid
  }), /*#__PURE__*/React.createElement("legend", null, labelChild), HelpTextComponent, ErrorMessageComponent, /*#__PURE__*/React.createElement("div", {
    className: props.isValid ? '' : 'form-group-error'
  }, props.options && props.options.map(option => {
    var id = "".concat(props.id, "-").concat(option.value);
    var radioAttributes = {
      ariaDescribedBy: "".concat(props.id, "-helptext"),
      checked: option.value === props.value,
      id,
      inline: props.inline,
      isValid: props.isValid,
      label: option.label,
      labelSecondary: option.labelSecondary,
      name: inputName,
      onChange: props.onChange,
      value: option.value
    };
    return /*#__PURE__*/React.createElement(RadioButton, _extends({}, radioAttributes, {
      key: id
    }));
  })));
};
RadioButtons.defaultProps = {
  inline: false,
  isValid: true
};
RadioButtons.propTypes = {
  ErrorMessageIconTheme: PropTypes.string,
  errormessage: PropTypes.string,
  headingId: PropTypes.string,
  headingTag: PropTypes.string,
  helptext: PropTypes.any,
  id: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  isLabelHeading: PropTypes.bool,
  isValid: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  required: PropTypes.bool,
  theme: PropTypes.string,
  value: PropTypes.string
};

export { RadioButtons };
